import WindowHandler from "@/ts/components/Handlers/WindowHandler";
import FunctionHandler from "@/ts/components/Handlers/FunctionHandler";
import ShariffLinkGeneratorFactory from "@/ts/components/Shariff/ShariffLinkGeneratorFactory";
import ShariffInjector from "@/ts/components/Shariff/ShariffInjector";
import FrontendHandler from "@/ts/components/Handlers/FrontendHandler";
import EtSlider from "@/ts/components/EtSlider";
import Warenkorb from "@/ts/components/Warenkorb";
import EtPersonalJson from "@/ts/components/EtPersonalJson";
import lightGallery from 'lightgallery';
import {formSubmitHandler_AddToCart_MultipleProducts} from "@/ts/components/artikelFunctions";

// Plugins ... enable plugin css in vbsr2/src/scss/artikel/_artikel_detail__lightgallery.scss
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'

export default function (vwtype: string, vwname: string): void {
    const resizeFunctionHandler: FunctionHandler = new FunctionHandler();

    if (!window.etData.defaultWishlistId) {
        window.etData.defaultWishlistId = 1;
    }

    WindowHandler.applyViewportClasses();
    let previousViewportWidth: number = window.innerWidth;
    let newViewportWidth: number;
    window.addEventListener("resize", FunctionHandler.debounce(
        resizeFunctionHandler.preventConcurrentExecution(async (): Promise<void> => {
            newViewportWidth = window.innerWidth;
            if (previousViewportWidth !== newViewportWidth) {
                WindowHandler.applyViewportClasses();
                previousViewportWidth = newViewportWidth;
            }
        }, true),
        100
    ));

    FrontendHandler.getPublicVar<Warenkorb>("warenkorb").addA2CEventListener();

    FrontendHandler.initWishlistButtons();

    if (ShariffInjector) {
        const shariff = new ShariffInjector(new ShariffLinkGeneratorFactory());
        shariff.initButtons(window.location.href);
    }

    // @ts-ignore
    document.removeEventListener("et.variantChanged", etVariantChangedEventHandler, {passive: true});
    // @ts-ignore
    document.addEventListener("et.variantChanged", etVariantChangedEventHandler, {passive: true});

    // TODO: nur die sichtbaren Slider initialisieren
    initPdsGallerySliders();

    EtPersonalJson.getInstance().fetchData().then((etPersonalJsonData) => {
        const pageViews = etPersonalJsonData.pageviews || 0;
        if (pageViews > 0) {
            document.querySelectorAll("[data-pageview-counter-value]").forEach((element: Element) => {
                if (element instanceof HTMLElement) {
                    element.innerHTML = pageViews.toString();
                    const parent = element.parentElement;
                    if (parent) {
                        parent.hidden = false;
                    }
                }
            });
        }

        /* Merkliste */
        const pj_merkzettel = etPersonalJsonData.wishlist?.merkzettel || {};
        const firstWishlistId = Number(Object.keys(pj_merkzettel)[0]);
        if (firstWishlistId > 0) {
            window.etData.defaultWishlistId = firstWishlistId;
        }
        // TODO evtl: Merkliste auswählen, anstatt standard-Liste (0) wählen
    });

    document.querySelectorAll(".js_artikel_detail__carousel_addition_add_artikel").forEach((button) => {
        if (!(button instanceof HTMLButtonElement) || !button.disabled) return;

        const formElement = button.form as HTMLFormElement;
        if (!formElement) {
            console.error("No form element found for button", {button});
            return;
        }
        button.disabled = false;

        formElement.addEventListener("submit", formSubmitHandler_AddToCart_MultipleProducts);
    });

    // Zoom functionality for swiper slider
    // Function to handle image zoom functionality
    function imageZoom(img: HTMLImageElement): void {
        if (!(img instanceof HTMLImageElement)) return;
        // Retrieve necessary elements

        const resizedImageForZoom = img.dataset.zoomImage;
        const imageForZoomRealWidth = Number(img.dataset.zoomImageWidth || 0);
        const imageForZoomRealHeight = Number(img.dataset.zoomImageHeight || 0);

        //make sure the image selected belongs to product_detail page
        const zoomBox = document.getElementById('zoomBox') as HTMLElement;
        const generalParent = document.querySelector('.artikel_detail__buybox_s2') as HTMLElement;
        if (!zoomBox || !zoomBox.parentElement || !generalParent) {
            console.error('Invalid zoomBox element');
            return;
        }

        const zoomBoxParent = zoomBox.parentElement;
        const containerWidth = generalParent.offsetWidth || 0;

        // Check if any required elements are missing
        if (!containerWidth) {
            console.error('Invalid containerWidth');
            return;
        }

        let lens: HTMLElement | null = document.querySelector(".artikel_detail__img-zoom-lens");
        let cx: number;
        let cy: number;

        if (!lens) {
            lens = document.createElement('div');
            lens.classList.add('artikel_detail__img-zoom-lens');
        }

        if (resizedImageForZoom && zoomBoxParent && img) {
            const aspectRatio = imageForZoomRealHeight / imageForZoomRealWidth;
            zoomBoxParent.style.width = Math.ceil(containerWidth) + "px";
            zoomBoxParent.style.height = Math.ceil(containerWidth * aspectRatio) + "px";

            img.insertAdjacentElement('beforebegin', lens);
            // Calculate the ratio between zoomBox DIV and lens

            cx = Math.round((zoomBox.offsetWidth / lens.offsetWidth) / 1.5 * 100) / 100;
            cy = Math.round((zoomBox.offsetHeight / lens.offsetHeight) / 1.5 * 100) / 100;

            // Execute a function when someone moves the cursor over the image, or the lens
            // TODO: event listener nur einmal registrieren
            img.addEventListener("mousemove", moveLens);

            function moveLens(e: MouseEvent): void {
                // Prevent any other actions that may occur when moving over the image
                e.preventDefault();

                // get cursor position relative to the image
                const a = img.getBoundingClientRect();
                // Calculate lens position
                const pos = {
                    x: e.pageX - a.left - window.scrollX,
                    y: e.pageY - a.top - window.scrollY
                };
                let x = pos.x;
                let y = pos.y;

                if (lens && typeof lens.offsetWidth !== 'undefined') {
                    x -= (lens?.offsetWidth / 1.5); // Adjusting for lens width
                    y -= (lens.offsetHeight / 1.5); // Adjusting for lens height
                    // Prevent the lens from being positioned outside the image
                    x = Math.round(Math.min(Math.max(x, 0), img.width - lens.offsetWidth));
                    y = Math.round(Math.min(Math.max(y, 0), img.height - lens.offsetHeight));
                    lens.style.left = `${x}px`;
                    lens.style.top = `${y}px`;
                }

                // Display what the lens "sees"
                if (zoomBox && img && resizedImageForZoom) {
                    zoomBox.style.backgroundImage = `url('${resizedImageForZoom}')`;
                    zoomBox.style.backgroundSize = `${img.width * cx}px auto`;
                    zoomBox.style.backgroundPosition = `-${x * cx}px -${y * cy}px`;
                }
            }
        }
    }

    // Function to remove zoom effect
    function removeZoom() {
        let lens = document.querySelector(".artikel_detail__img-zoom-lens") as HTMLElement;
        if (lens && lens.parentNode) {
            lens.parentNode.removeChild(lens);
        }

        let zoomBox = document.getElementById("zoomBox") as HTMLElement;
        if (zoomBox && zoomBox.parentElement) {
            zoomBox.setAttribute('style', '');
            zoomBox.parentElement.setAttribute('style', '');
        }
    }

    // Add event listeners to all images with zoom functionality

    document.querySelectorAll<HTMLImageElement>("img.js_zoomImg[data-zoom-image]").forEach((img) => {
        // Add mouseenter and mouseout event listeners
        img.addEventListener('mouseenter', () => {
            imageZoom(img);
        });
        img.addEventListener('mouseout', () => {
            removeZoom();
        });
        img.addEventListener('click', () => {
            removeZoom();
        });
    });

    const modalBodyElement = document.querySelector('.modal-body');
    // Preventing the lightbox function to be triggered more than once
    if ((modalBodyElement && modalBodyElement.getAttribute('data-template-loaded') === 'true')) {
        return;
    } else {
        // If no element with the class 'modal-body' exists start the lightbox
        const lightBoxImages = document.querySelectorAll<HTMLImageElement>("img.js_zoomImg[data-lightbox-image]");

        // Open lightGallery when an image is clicked
        lightBoxImages.forEach((img, index) => {
            img.addEventListener('click', activateLightBox);

            // Activate Lightbox when no modal is present.
            function activateLightBox() {
                // Prepare the dynamic elements for the lightGallery
                const dynamicEl = Array.from(lightBoxImages)
                    .filter(FrontendHandler.isVariantOfElementActive)
                    .map(img => ({
                        src: img.dataset.lightboxImage,
                        thumb: img.dataset.lightboxThumbnail || img.src,
                        subHtml: `<div class="lightGallery-captions"><h4>${img.alt}</h4></div>`,
                        subHtmlUrl: img.dataset.subHtmlUrl || ''
                    }));

                // Initialize lightGallery with dynamic elements
                const inlineGallery = lightGallery(document.body, {
                    plugins: [lgThumbnail, lgZoom],
                    dynamic: true,
                    licenseKey: '415B960F-32AF-4601-96E6-60E098F7A0FE',
                    closable: true,
                    slideDelay: 100,
                    dynamicEl: dynamicEl,
                    showCloseIcon: true,
                    controls: true,
                    hideScrollbar: true,
                });

                // Open the gallery at the specified index
                const index = 0;
                inlineGallery.openGallery(index);

                // Clean up lightGallery container divs after use
                document.body.addEventListener('click', function (event) {
                    if (event.target.classList.contains('lg-close')) {
                        const lgContainer = document.querySelector('.lg-container');
                        if (lgContainer) {
                            lgContainer.remove();
                        }
                    }
                });
            }

        });
    }

    // at the very end of all this default stuff... to init the wishlist buttons in quickview with cached data
    etPersonalJson.fetchData(true);
}

function initPdsGallerySliders(variantId?: number) {
    const dataAttributeValue = typeof variantId === "number" && variantId > 0 ? `="${variantId}"` : '';
    const selector = `[data-sync-slider-main${dataAttributeValue}]:not(.swiper-initialized)`;

    document.querySelectorAll(selector).forEach(async (mainSliderElement) => {
        if (!(mainSliderElement instanceof HTMLElement)) return;
        const pid = mainSliderElement.dataset.syncSliderMain;
        const thumbsSliderElement = document.querySelector(`[data-sync-slider-thumbs='${pid}']`);

        let thumbsSliderApi: any = null;
        if (thumbsSliderElement instanceof HTMLElement) {
            try {
                const initSliderResult = await EtSlider.initSlider(thumbsSliderElement);
                thumbsSliderApi = initSliderResult.swiperApi;
            } catch (e) {
                // passt schon
            }
        }

        const mainSliderOptions = EtSlider.getSliderConfig(mainSliderElement);
        if (thumbsSliderApi) {
            mainSliderOptions.thumbs = {
                swiper: thumbsSliderApi,
            };
        }

        // console.debug("initPdsGallerySliders", {mainSliderElement, mainSliderOptions});
        EtSlider.initSlider(mainSliderElement, mainSliderOptions);
    });
}

function etVariantChangedEventHandler(event: CustomEvent): void {
    // {detail: {masterId, variantId}})
    if (!event || !event.detail) return;

    // console.debug("etVariantChangedEventHandler", event.type, event.detail);
    initPdsGallerySliders(event.detail.variantId || 0);
}